export const initialState = {
  assistiveTechnologies: [],
  assistiveTechnology: {},
  assistiveTechnologyPatients: [],
  filters: {}
};
